import Raven from 'raven-js';

if ((['production', 'staging'] as any).includes(process.env.CONFIG)) {
  Raven
    .config(require('../config').sentryDNS, {
      environment: process.env.CONFIG,
      release: process.env.GIT_SHA
    })
    .install();
}
